import Vue from "vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { VueAxios } from './utils/request'
import { apiPlugin } from './api/list'
import SlideVerify from 'vue-monoplasty-slide-verify';

Vue.use(SlideVerify);

// mount axios Vue.$http and this.$http
Vue.use(VueAxios)

// mount system apis Vue.apis and this.apis
Vue.use(apiPlugin)

Vue.config.productionTip = false;
Vue.use(Antd);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
